import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["switch"]

  toggle(event) {
    this.switchTargets.forEach((element) => {
      element.classList.remove("is-active")
    })
    event.currentTarget.classList.add("is-active")
  }
}
